export default "__VITE_ASSET__q7P9QWwc__"